import _ from "lodash";
import { prepareSelectOptions } from "../../hooks/form-helpers";

export const splitProductFilters = (filterDetails) => {
  const filters = {};
  if (!_.isEmpty(filterDetails)) {
    Object.keys(filterDetails)
      .filter((key) => key.includes("products."))
      .forEach((productFilterKey) => {
        const filterKey = productFilterKey.split("products.")[1];
        filters[filterKey] = filterDetails[productFilterKey];
      });
  }

  return filters;
};

export const getProductFilters = (filter) => {
  if (_.isEmpty(filter)) return {};

  const splittedFilters = splitProductFilters(filter);

  const { minVolume, maxVolume, minPrice, maxPrice } = splittedFilters;

  return {
    ...(minVolume && { minVolume }),
    ...(maxVolume && { maxVolume }),

    ...(minPrice && { minPrice }),
    ...(maxPrice && { maxPrice }),
    ...locationFilter(filter),
  };
};

const locationFilter = (filter) => {
  const locationFilterKey = "location.distanceMeters";
  if (filter && filter.latitude) {
    return {
      "location.distanceMeters": filter[locationFilterKey],
      "location.latitude": filter.latitude,
      "location.longitude": filter.longitude,
      sort: "distance,DESC",
    };
  }

  return {};
};


export const getMaterialAssociatedOptions = (materials, optionCode) => {
  const filteredMaterials = [];
  materials.forEach((item) => {
    if (item.associatedOptionCodes.includes(optionCode)) {
      filteredMaterials.push(item);
    }
  });

  return prepareSelectOptions(filteredMaterials, "code", "defaultTitle", "id");
};
